import { render, staticRenderFns } from "./foodPackLog.vue?vue&type=template&id=63728e02&scoped=true&"
import script from "./foodPackLog.vue?vue&type=script&lang=js&"
export * from "./foodPackLog.vue?vue&type=script&lang=js&"
import style0 from "./foodPackLog.vue?vue&type=style&index=0&id=63728e02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63728e02",
  null
  
)

export default component.exports